import { uploadTrialRecord } from '@/apis/paiban'
import { uploadJsonToOss } from '@yige/utils'
import { Message } from 'element-ui'

/** 下载 NC 传给 /new_nc 的小板字段白名单 */
export const NC_PART_FIELD_KEYS = [
  'address',
  'auto_index',
  'connection_types',
  'createTime',
  'curveHoles',
  'curve_layered_cutting',
  'curve_layered_cutting_deep',
  'customer_name',
  'cutCurve',
  'cutCurveEx',
  'cutOrigin',
  'depth',
  'drawerStyle',
  'designer',
  'edgeInfo',
  'edgeInfo_desc_LW',
  'edgePreMillingInfo',
  'edge_length_info',
  'engraving_cut_curve',
  'extraInfo',
  'form_data',
  'force_board_name',
  'frame_door_children',
  'fullSize',
  'ggid',
  'handle',
  'handleSlopes',
  'hasAutoRollOver',
  'holes',
  'inPlankStockNum',
  'isDesMaterialNoCut',
  'is_high_gloss_plank',
  'isUseSaw',
  'isWeldingPlank',
  'labelId',
  'layout_time',
  'lineSlots',
  'loc',
  'longPlankFlag',
  'margin',
  'matCode',
  'matRotatable',
  'millInfo',
  'model_front_edge',
  'name',
  'newTexture',
  'oPath',
  'oRect',
  'orderId',
  'orderNo',
  'order_create_time',
  'oriCurveHoles',
  'oriPlankNum',
  'openDir',
  'parentType',
  'partName',
  'partUniqueId',
  'partMaskName',
  'path',
  'plank_remarks',
  'plankHeight',
  'plankWidth',
  'plankID',
  'plankNum',
  'plankNumType2',
  'plankType',
  'plank_serial_number',
  'priority',
  'process_label',
  'realCurve',
  'realCurveEx',
  'realRect',
  'rect',
  'remark',
  'render_url',
  'roomID',
  'roomName',
  'sholes',
  'simplePlankNum',
  'slots',
  'srcTexDir',
  'smoothEdge',
  'specialType',
  'specialFlag',
  'surplusPath',
  'sslots',
  'startX',
  'startY',
  'stockKey',
  'stockNum',
  'surplusInfo',
  'symbol',
  'texDir',
  'texture',
  'thick',
  'type',
  'userName',
  'wardrobeName',
] as const

/**
 * 按白名单裁剪小板字段，去掉下载 NC 时无用字段
 */
export function pickNcPartFields(part: Record<string, any>) {
  const result: Record<string, any> = {}
  NC_PART_FIELD_KEYS.forEach((key) => {
    if (part[key] !== undefined) {
      result[key] = part[key]
    }
  })
  return result
}

/**
 *发送试生产记录
 * @param nc nc接口返回数据
 * @param ncSetting nc设置
 * @returns
 */
export async function sendTrialRecord(nc: any[], ncSetting: any) {
  if (!nc.length) return
  for (const ncFile of nc) {
    if (
      (ncFile.error_info && !ncFile.plank_size_abnormal) ||
      (ncFile.filetype === 'nc' && ncFile.plank_size_abnormal)
    ) {
      return
    }
  }
  const fileUrl = await uploadJsonToOss(
    nc,
    'trial_record',
    'trial_production_record_dir',
    true
  )
  const result = await uploadTrialRecord({
    process_id: ncSetting.process_setting_id,
    process_name: ncSetting.process_setting_name,
    from: 'web',
    produce_file_url: fileUrl,
  })
  if (result.status !== 1) {
    Message.error({
      center: true,
      message: result.msg,
    })
  }
}
